export const docToObject = snapshot => ({ id: snapshot.id, ...snapshot.data() })
export const docsToArray = snapshot => snapshot.docs.map(doc => docToObject(doc))
export const toDate = value => new Date((value._seconds || value.seconds) * 1000)
